import Component from '../inherited/Component'

export default class LocalizationForm extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this.input = this._elem.querySelector('input[name="locale_code"], input[name="country_code"]'),
    this.button = this._elem.querySelector('button'),
    this.panel = this._elem.querySelector('.disclosure__list-wrapper'),
    this.isoCodes = [...this._elem.querySelectorAll('.currency__item')]
  }

  async mount () {
  	if (this.button) {
	    this.button.addEventListener('click', this.openSelector.bind(this));
	    this.button.addEventListener('focusout', this.closeSelector.bind(this));
  	}
    this._elem.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this._elem.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    // this.hideDuplicates();
  }

  hidePanel() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', true);
  }

  hideDuplicates() {
    const texts = new Set(this.isoCodes.map(x => x.getAttribute('data-iso-code')));
    this.isoCodes.forEach(el => {
      if(texts.has(el.getAttribute('data-iso-code'))){
        texts.delete(el.getAttribute('data-iso-code'));
      }
      else{
        el.remove()
      }
    })
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this._elem.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.button.focus();
    this.panel.toggleAttribute('hidden');
    this.button.setAttribute('aria-expanded', (this.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}